export default __webpack_public_path__ + "static/media/img-0705-belgium-full-face.20fe23ac.png";